import { FC } from "react"
import ReactQuill from "react-quill"

import "react-quill/dist/quill.snow.css"

interface TermsAndConditionsBuilderProps {
  value: string | null
  onChange: (html: string) => void
}

const modules = {
  toolbar: [[{ header: [2, 3, false] }], ["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], ["link"], ["clean"]]
}

const formats = ["header", "bold", "italic", "underline", "list", "bullet", "link"]

export const TermsAndConditionsBuilder: FC<TermsAndConditionsBuilderProps> = ({ value, onChange }) => {
  return (
    <div className="bg-white rounded-md overflow-hidden text-black">
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder="Enter terms and conditions..."
        style={{ minHeight: 200 }}
      />
    </div>
  )
}
